// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`


if (tonemappingData.type == TONEMAP_LINEAR){

	gl_FragColor.rgb = LinearToneMapping(gl_FragColor.rgb, tonemappingData.exposure);

} else if (tonemappingData.type == TONEMAP_REINHARD){

	gl_FragColor.rgb = ReinhardToneMapping(gl_FragColor.rgb, tonemappingData.exposure);	

} else if (tonemappingData.type == TONEMAP_CINEON){

	gl_FragColor.rgb = OptimizedCineonToneMapping(gl_FragColor.rgb, tonemappingData.exposure);
	// debugColor.rgb = vec3(1.0, 0.0, 0.0);
	
} else if (tonemappingData.type == TONEMAP_ACES){

	gl_FragColor.rgb = ACESFilmicToneMapping(gl_FragColor.rgb, tonemappingData.exposure);
	
} else if (tonemappingData.type == TONEMAP_CUSTOM){

	gl_FragColor.rgb = LinearToneMapping(gl_FragColor.rgb, tonemappingData.exposure);
	
} else if (tonemappingData.type == TONEMAP_NONE){
	// just for debugging, could be removed
}

`;